import { EnvService } from './services/env.service';
import { EnvServiceFactory } from 'src/services/env-factory.service';

/* eslint-disable */

export const configureGoogleAnalytics = () => {
    const env: EnvService = EnvServiceFactory();
    if (env.GOOGLE_ANALYTICS_TRACKING_ID) {
        let gtagLoad = document.createElement('script');
        gtagLoad.async = true;
        gtagLoad.src = `https://www.googletagmanager.com/gtag/js?id=${ env.GOOGLE_ANALYTICS_TRACKING_ID };`;
        document.head.appendChild(gtagLoad);

        let gtagConfigure = document.createElement('script');
        gtagConfigure.innerHTML = `
 	 	    window.dataLayer = window.dataLayer || [];
 	 	 	function gtag() { 
 	 	 	    dataLayer.push(arguments); 
 	 	 	}
 	 	 	gtag('js', new Date());
 	 	 	gtag('config', '${ env.GOOGLE_ANALYTICS_TRACKING_ID }', { 'send_page_view': false });
 	 	`;
        document.head.appendChild(gtagConfigure);
    }
};
